<template>
  <!-- Botón flotante arriba-derecha para abrir/cerrar el panel lateral (chrome
       compartido, mismo icono/estilo que solar-park). Oculto cuando el panel
       está fijado (docked): ahí se gestiona con su propia chincheta/cerrar. -->
  <div class="epc-panel-toggle" v-if="!pinned">
    <b-tooltip :label="$t('side_panel')" position="is-bottom">
      <div class="epc-action-btn" :class="{ 'is-active': active }"
        data-action="toggle-sidebar" role="button" :aria-label="$t('side_panel')"
        @click="$emit('epc-toggle')">
        <svg class="epc-panel-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"
          aria-hidden="true" focusable="false" role="img">
          <path fill="none" d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path>
          <path fill="none" d="M15 4l0 16"></path>
        </svg>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: "WidgetPanelToggle",

  props: {
    // Resalta el botón cuando el panel está abierto.
    active: { type: Boolean, default: false },
    // Oculta el botón cuando el panel está fijado (acoplado).
    pinned: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.epc-panel-toggle {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 6;
}

.epc-action-btn {
  background-color: #ffffff;
  border: 1px solid #e3e3e8;
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  color: #343a40;
}

.epc-action-btn:hover {
  background-color: #f4f4f6;
  color: #3a6bc8;
}

.epc-action-btn.is-active {
  background-color: #efeffb;
  border-color: #d9d9f5;
  color: #6965db;
}

.epc-panel-icon {
  width: 17px;
  height: 17px;
}

/* El icono es de contorno: forzamos sin relleno por si alguna regla global
   rellena los <path> (pisaría el atributo fill="none"). */
.epc-panel-icon,
.epc-panel-icon path {
  fill: none;
}
</style>
